module.exports = "/packs/images/svg/ireland/facilities/bicycle~8c161f7c99db792f62039c8ee0727013.svg";